import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IVessel } from '../contracts/vessel.contract';
import { VesselService } from '../services';

interface IInitialState {
    List: {
        Vessels: IVessel[] | undefined;
        IsLoading: boolean;
        ErrorMessage: string | undefined;
    };
    UserSearchQuery: string | undefined;
}

const initialState: IInitialState = {
    List: {
        Vessels: undefined,
        IsLoading: false,
        ErrorMessage: undefined
    },
    UserSearchQuery: undefined
};

const Fetch = {
    GetAll: createAsyncThunk('vessel/GetAll', async (_, { rejectWithValue }) => {
        try {
            const res = await VesselService.getAll();
            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    })
};

const VesselSlice = createSlice({
    name: 'vessel',
    initialState: initialState,
    reducers: {
        SetErrorMessage: (state, action: PayloadAction<string | undefined>) => {
            state.List.ErrorMessage = action.payload;
        },
        SetUserSearchQuery: (state, action: PayloadAction<{ UserSearchQuery: string | undefined }>) => {
            state.UserSearchQuery = action.payload.UserSearchQuery;
        }
    },
    extraReducers: (builder) => {
        // GetAll
        builder.addCase(Fetch.GetAll.pending, (state, action) => {
            state.List.Vessels = undefined;
            state.List.IsLoading = true;
            state.List.ErrorMessage = undefined;
        });
        builder.addCase(Fetch.GetAll.fulfilled, (state, action: PayloadAction<IVessel[]>) => {
            state.List.Vessels = action.payload;
            state.List.IsLoading = false;
            state.List.ErrorMessage = undefined;
        });
        builder.addCase(Fetch.GetAll.rejected, (state, action) => {
            state.List.Vessels = undefined;
            state.List.IsLoading = false;
            state.List.ErrorMessage = action.payload?.toString();
        });
    }
});

export const VesselFetch = Fetch;
export const VesselAction = VesselSlice.actions;
export const VesselReducer = VesselSlice.reducer;
